module.exports = __webpack_public_path__ + "9284a37f0fc24e85534516a76da8a235.svg";